import { render, staticRenderFns } from "./CompetitorsActionsRenderer.vue?vue&type=template&id=7825e34a&scoped=true&"
import script from "./CompetitorsActionsRenderer.vue?vue&type=script&lang=js&"
export * from "./CompetitorsActionsRenderer.vue?vue&type=script&lang=js&"
import style0 from "./CompetitorsActionsRenderer.vue?vue&type=style&index=0&id=7825e34a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7825e34a",
  null
  
)

/* custom blocks */
import block0 from "./CompetitorsActionsRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports